module.exports = __webpack_public_path__ + "media/images/icon__calendar@2x-d33a1140c01107670e960e681f48d339.png";